/**
 *
 * @param {string} url
 * @param {string,number} width
 * @returns {string} url
 * @description: 根据url和width生成处理过后的图片url
 */
export const processImageUrl = (url, width) => {
  // 判断是否包含 .hpplay.cn/
  const domainRegex = /\.hpplay\.cn\//;
  if (!domainRegex.test(url)) {
    return url; // 如果不包含指定域名，直接返回原 URL
  }

  const processStr = `?x-oss-process=image/resize,limit_1,m_lfit,w_${width}`;
  const processRegex = /\?x-oss-process=image\/resize,limit_1,m_lfit,w_(\d+)/;

  if (processRegex.test(url)) {
    // 找到最后一个匹配的子串位置
    const lastIndex = url.lastIndexOf('?x-oss-process=image/resize,limit_1,m_lfit,w_');
    // 进行替换
    const beforeProcess = url.substring(0, lastIndex);
    const afterProcess = url.substring(lastIndex).replace(processRegex, processStr);
    return beforeProcess + afterProcess;
  } else {
    // 如果不包含处理字符串，则拼接处理字符串
    return url + processStr;
  }
}
/**
 *
 * @param {string} url
 * @returns {string} width
 * @description: 从图片url中提取width
 */
export const extractWidth = (url) => {
  const processRegex = /\?x-oss-process=image\/resize,limit_1,m_lfit,w_(\d+)/;
  const match = url.match(processRegex);

  if (match && match[1]) {
    return match[1];
  } else {
    return false
  }
}

